import { get } from 'lodash';
import { SectionType } from '../../types';
import * as defaults from '../defaults';
import { getRegionSpacing } from '../get-section-padding';
export function getFooterTweaksForSmallScreens() {
    return `
    .html-email-body-section-footer > table > tbody > tr > td {
      padding-bottom: 10px!important;
    }
  `;
}
export function getFooterTweaksInSimulatorForSmallScreens({ css }) {
    const sectionSpacingObject = getRegionSpacing(css, SectionType.footer);
    let topPadding = sectionSpacingObject.padding.top;
    if (topPadding > 24) {
        topPadding = 24;
    }
    return `
    .html-email-body-section-footer > table > tbody > tr > td {
      padding-top: ${topPadding}px!important;
    }

    .html-emails-footer-section > table > tbody > tr > td {
      padding: 0!important;
    }

    .footer-top-spacer {
      padding: 0!important;
    }
  `;
}
export function getFooterSeparatorForLargeScreensCss({ css, sections }) {
    const footer = sections.find(({ type }) => type === 'footer');
    // Separator color needs to be checked in multiple places,
    // cause inside composer and email service it's being stored in different places.
    const footerSeparatorColor = footer?.footer?.separatorColor ||
        footer?.separatorColor ||
        get(css, 'so-global-footer-separator.borderColor') ||
        defaults.defaultTextColor;
    return `
    .html-emails-footer-section.show-border-right > table {
      border-right: 1px solid ${footerSeparatorColor} !important;
    }

    .html-emails-footer-section.show-border-left > table {
      border-left: 1px solid ${footerSeparatorColor} !important;
    }

    .html-emails-footer-section.bigger-column-height > table {
      height: 67px!important;
    }
  `;
}
export function getFooterDividerCss() {
    return `
    .html-emails-footer-divider {
      display: none;
    }
  `;
}
export function getFooterDividerSmCss() {
    return `
    .html-emails-footer-divider {
      display: block !important;
      padding-bottom: 18px!important;
      padding-top: 18px!important;
    }
    .html-emails-footer-divider > * {
      width: 70px!important;
      border-width: 1px!important;
    }
    .html-emails-footer-site-with-mobile-divider {
      padding-top:0px!important;
      padding-bottom:0px!important;
    }

    .html-emails-footer-business-details-with-mobile-divider {
      padding-bottom:0px!important;
    }
  `;
}
export function getMobilePlaceSmCss() {
    return `
    .html-emails-footer-mobile-place-section > table > tbody > tr > td {
      padding-top: 8px!important;
      padding-bottom: 10px!important;
    }

    .html-emails-footer-mobile-place-section-no-divider > table > tbody > tr > td {
      padding-top: 20px!important;
      padding-bottom: 10px!important;
    }

    .html-emails-footer-mobile-place-divider {
      padding-top: 0px!important;
      padding-bottom: 18px!important;
    }
    .html-emails-footer-mobile-place-divider > * {
      width: 70px!important;
    }
    .html-emails-footer-mobile-place-text {
      padding: 0 20px!important;
    }
    .html-emails-footer-mobile-place-cta {
      padding: 10px 20px 0!important;
    }
  `;
}
export function getFooterSectionStyle() {
    const smScreen = [
        getFooterTweaksForSmallScreens,
        getFooterDividerSmCss,
        getFooterTweaksInSimulatorForSmallScreens,
        getMobilePlaceSmCss,
    ];
    const lgScreen = getFooterSeparatorForLargeScreensCss;
    const allScreens = getFooterDividerCss;
    return {
        smScreen,
        lgScreen,
        all: allScreens,
    };
}
//# sourceMappingURL=get-footer-section-style.js.map